import React from 'react';
import GeckoTableCellBase from '../_base.jsx';

class GeckoTableCellDefault extends GeckoTableCellBase {
  render() {
    return <div>{this.renderValue()}</div>;
  }
}

export default GeckoTableCellDefault;
